export default function validateName(value?: string) {
  let error;
  if (value === 'admin') {
    error = 'Nice try!';
  }
  return error;
}
